import React from "react";

function ServiceTable({
  services,
  title,
  isPending,
  isArchived,
  handleCompleteService,
  handleArchiveService,
  handleRestoreService,
  handleReferService,
  serviceCounts={} // ✅ اضافه کن
})

{  return (
    <div className="service-table-container">
      <h2>{title}</h2>
      {services.length === 0 ? (
        <p>No services to display.</p>
      ) : (
        <table className="service-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>Phone</th>
	      <th>Brand</th>
     	      <th>Model</th>
     	      <th>Year</th>
     	      <th>Trim</th>
              <th>Services</th>
              <th>Requested Date</th>
              <th>Requested Time</th>
              <th>Actions</th>
<th>🧾 Total Services</th>

            </tr>
          </thead>
          <tbody>
            {services.map((srv, idx) => (
              <tr key={idx}>
         <td>{srv.Name}</td>
	 <td>{srv.Address}</td>
 	<td>{srv.Phone}</td>
        <td>{srv.Brand}</td>
        <td>{srv.Model}</td>
        <td>{srv.Year}</td>
        <td>{srv.Trim}</td>
        <td>{srv.Services}</td>
        <td>{srv["Requested Date"]}</td>
        <td>{srv["Requested Time"]}</td>
<td>{serviceCounts?.[srv.Email] || 1}</td>

              <td>
  {isPending && (
    <>
      <button onClick={() => handleCompleteService(srv)}>
        Complete
      </button>
      {srv.ReferralStatus !== "Referred" && (
        <button onClick={() => handleReferService(srv)}>
          Refer
        </button>
      )}
    </>
  )}
  {!isPending && !isArchived && (
    <button onClick={() => handleArchiveService(srv)}>
      Archive
    </button>
  )}
  {isArchived && (
    <button onClick={() => handleRestoreService(srv)}>
      Restore
    </button>
  )}
</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ServiceTable;
